import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import Permission from './components';

const routes = () => (
  <PrivateRoute exact path='/settings/Permissions' component={Permission} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Permissions/routes.js